'use client';

import { useLabel } from '@websolutespa/bom-mixer-hooks';
import { AnimatePresence } from 'motion/react';
import React from 'react';
import { useLlm } from '../../../useLlm/useLlm';

export type StreamProps = {
  index: number;
  className?: string;
};

export const Stream: React.FC<StreamProps> = ({ index, className }) => {
  const label = useLabel();
  const {
    BusyIndicator,
    ChunkWrapper,
  } = useLlm(state => state.components);
  const chunks = useLlm(state => state.chunks);
  return (
    <>
      {chunks && (
        <>
          <div
            className={className || 'llm__message llm__message--assistant'}
            role="region"
            aria-label={label('llm.answer')}
          >
            <AnimatePresence>
              {chunks.map((chunk, c) => (
                <ChunkWrapper
                  key={`llm-message-${index}-chunk-${c}`}
                  className={`llm__inner llm__inner--${chunk.type}`}
                  item={chunk} chunkIndex={c} index={index} total={index + 1} role="assistant"
                  stream
                />
              ))}
              <BusyIndicator />
            </AnimatePresence>
          </div>
        </>
      )}
    </>
  );
};
